<template>
    <v-form @submit.prevent="sendOrder" ref="refOrder" lazy-validation>
        <v-card tile elevation="0">
            <v-card-text class="pa-0">
                <v-card-title class="py-3 blue-grey lighten-5">
                    {{ $t('Datos del cliente') }}
                </v-card-title>
                <div class="pa-3">
                    <v-row>
                        <v-col cols="6">
                            <v-text-field
                                :label="$t('Nombre completo *')"
                                :color="btnColor"
                                outlined
                                dense
                                v-model="dataPrch.fullName"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="6">
                            <vue-tel-input-vuetify
                                :label="$t('Celular (opcional)')"
                                :color="btnColor"
                                outlined
                                dense
                                :defaultCountry="iso2"
                                :onlyCountries="[iso2]"
                                :value="tmpPhone"
                                @input="onInput"
                            ></vue-tel-input-vuetify>
                        </v-col>
                        <v-col cols="6" v-if="showTable">
                            <v-text-field
                                :label="$t('Número de mesa *')"
                                :color="btnColor"
                                outlined
                                dense
                                type="number"
                                min="0"
                                step="1"
                                v-model="dataPrch.tableNumber"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-checkbox
                                v-model="dataPrch.remarkOrder"
                                :color="btnColor"
                                :label="$t('Incluir un comentario para la orden')"
                                hide-details
                            ></v-checkbox>
                            <!-- commentOrder -->
                            <v-textarea
                                :placeholder="$t('Ejm. Si es posible un poco de sal extra por favor.')"
                                outlined
                                :color="btnColor"
                                rows="3"
                                v-model="dataPrch.commentOrder"
                                v-if="dataPrch.remarkOrder"
                                :rules="[rules.required]"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </div>
                <v-card-title class="py-3 blue-grey lighten-5">
                    {{ $t('Resumen de orden') }}
                </v-card-title>
                <div class="pa-3">
                    <v-simple-table dense class="mb-5">
                        <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left grey--text text--lighten-1">
                                    {{ $t('Cantidad') }}
                                </th>
                                <th class="text-left grey--text text--lighten-1">
                                    {{ $t('Producto') }}
                                </th>
                                <th class="text-right grey--text text--lighten-1">
                                    {{ $t('Precio') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in cart" :key="i">
                                <td class="text-left">{{ item.quantity }}x</td>
                                <td class="text-left">{{ item.name }}</td>
                                <td class="text-right">{{ money }} {{ item.price }}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>
                                    <strong class="text-h6">{{ $t('Subtotal') }}</strong>
                                </td>
                                <td colspan="2" class="text-right">
                                    <strong class="text-h6">{{ money }} {{ total }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong class="text-h5">{{ $t('Total') }}</strong>
                                </td>
                                <td colspan="2" class="text-right">
                                    <strong class="text-h5">{{ money }} {{ (total>0)?total:0 }}</strong>
                                </td>
                            </tr>
                        </tfoot>
                        </template>
                    </v-simple-table>
                </div>
            </v-card-text>

            <v-card-actions class="pa-3">
                <v-row>
                    <v-col cols="4">
                        <v-btn
                            rounded
                            large
                            text
                            :color="btnColor"
                            class="text-capitalize"
                            block
                            @click="$emit('close-purchase')"
                        >{{ $t('Cancelar') }}</v-btn>
                    </v-col>
                    <v-col cols="8">
                        <v-btn
                            rounded
                            large
                            :color="btnColor"
                            :style="`color:${textbtnColor}`"
                            class="text-capitalize"
                            block
                            type="submit"
                            :disabled="JSON.stringify(cart) == '{}'"
                        >{{ $t('Confirmar pedido') }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>

            <!-- overlay -->
            <v-overlay :value="loading" absolute opacity=".9" z-index="10">
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="primary"
                ></v-progress-circular>
            </v-overlay>
            <!-- end overlay -->
        </v-card>
    </v-form>
</template>
<script>
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue';
// Vue.use(VueTelInputVuetify);
    export default {
        components: {
            VueTelInputVuetify,
        },
        data () {
            return {
                overlay: false,
                loading: false,
                // list data
                listProducts: [],
                pageTable: '',
                page: 1,
                totalPage: null,
                txtSearch: '',
                // cart
                cantProds: 0,
                total: 0,
                // dialog
                overlayProd: false,
                loadProd: true,
                dialogProd: false,
                prodId: '',
                bannerProd: '',
                galleryProd: [],
                nameProd: '',
                typeProd: '',
                descriptionProd: '',
                optionsProd: [],
                quantity: 1,
                price: null,
                stock: 500,
                dataExtra: '',
                respMultiple: [],
                respMultipleVal: 0,
                respOnly: [],
                respOnlyVal: 0,
                showRequired: false,
                showAlertRequired: false,
                // reservation
                menu1: false,
                menu2: false,
                fullName: '',
                phoneNumber: '',
                dateReservation: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
                dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
                timeReservation: '14:00',
                loadingServ: false,
                // cart
                openCart: false,
                cart: {},
                tmpIndex: null,
                // purchase
                dialogPurchase: false,
                codePhone: '',
                dataPrch: {
                    fullName: '',
                    remarkOrder: false,
                    commentOrder: '',
                    tableNumber: '',
                },
                showTable: true,
                tmpPhone: '',
                phoneCode: '',
                phoneValid: false,
                phoneNumber: '',
                phoneIso: '',
                // validation
                ifNewProd: true,
                rules: {
                    required: v => !!v || 'El campo es requerido',
                    requiredDates: v => v.length>0 || 'El campo es requerido',
                    min: v => v.length >= 8 || 'Mínimo 8 caracteres',
                    phone: v => (v.length >= 8 && v.length <= 8) || 'Debe contener 8 dígitos',
                    email: v => /.+@.+\..+/.test(v) || 'Correo electrónico inválido'
                },
            }
        },
        props: [
            'slug',
            'mesa',
            'titleColor',
            'btnColor',
            'textbtnColor',
            'bannerColor',
            'textnavColor',
            'navColor',
            'dataMyStore',
            'fontFamily',
            'upCart',
            'lastPurchase',
            'closedStore',
            'money',
            'tempMode',
            'iso2',
            'valCoupon',
            'nameCoupon',
        ],
        computed: {
            computedDateFormatted () {
                return this.formatDate(this.date)
            },
        },
        watch: {
            upCart(newVal, oldVal) { // watch it
                // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
                this.updateCart()
                this.e1 = 1
            },
            dialogProd(e) {
                if (!e) {
                    this.respMultiple = []
                    this.respMultipleVal = 0

                    this.respOnly = []
                    this.respOnlyVal = 0

                    this.dataExtra = ''

                    this.optionsProd = []
                }
            },
            dateReservation (val) {
                this.dateFormatted = this.formatDate(this.date)
            },
        },
        mounted() {
            this.updateCart()

            if (JSON.stringify(this.lastPurchase) != '{}') {
                this.fullName = this.lastPurchase.full_name
                this.phoneCode = this.lastPurchase.code
                this.phoneNumber = this.lastPurchase.phone_number
                this.tmpPhone = this.phoneCode + this.phoneNumber
                this.deliveryMethod = this.lastPurchase.delivery_method
                this.tmpLat = (this.lastPurchase.lat_map)?+this.lastPurchase.lat_map:-17.3751345
                this.tmpLng = (this.lastPurchase.lng_map)?+this.lastPurchase.lng_map:-66.1844502
                this.deliveryAddress = this.lastPurchase.delivery_address
                this.addressClarification = this.lastPurchase.address_clarification

                this.showMap = true
            }

            if (this.mesa) {
                this.showTable = false
                this.dataPrch.tableNumber = this.mesa;
            }
        },
        methods: {
            onInput(formattedNumber, { number, valid, country }) {
                this.phoneCode = '+'+country.dialCode
                this.phoneNumber = number.significant
                this.tmpPhone = number.international
                this.phoneValid = valid
                this.phoneIso = country.iso2
            },
            /**
             * upload cart
             */
            updateCart(){
                if (localStorage.getItem(this.slug)) {
                    this.cart = JSON.parse(localStorage.getItem(this.slug))
                    this.calculateTotal()
                }
            },
            /**
             *
             */
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },
            /**
             * update cart
             */
            updateCartTmp(cart) {
                this.cart = JSON.parse(cart)

                for (var [key, value] of Object.entries(this.cart)) {
                    var tmpComplements = this.cart[key].complements
                    this.cart[key].complementsDetails = ''
                    if (tmpComplements.multi.length > 0) {
                        tmpComplements.multi.forEach(element => {
                            this.cart[key].complementsDetails += element.split(':')[0]
                            this.cart[key].complementsDetails += ', '
                        });
                    }
                    if (tmpComplements.only.length > 0) {
                        tmpComplements.only.forEach(element => {
                            this.cart[key].complementsDetails += element.split(':')[0]
                            this.cart[key].complementsDetails += ', '
                        });
                    }
                }

                this.cantProds = Object.keys(this.cart).length;
                this.calculateTotal()
            },
            /**
             * update cart
             */
            updateToCart() {
                this.showAlertRequired = false
                if (this.showRequired) {
                    this.showAlertRequired = true
                    return
                }
                this.overlayProd = true
                const cart = {
                        prodId: this.prodId,
                        name: this.nameProd,
                        // price: this.price,
                        price: (this.quantity * this.price) + this.respMultipleVal + this.respOnlyVal,
                        quantity: this.quantity,
                        extra: this.dataExtra,
                        complements: {
                            multi: this.respMultiple,
                            only: this.respOnly
                        }
                    }

                if (localStorage.getItem(this.slug)) {
                    const tmpCart = JSON.parse(localStorage.getItem(this.slug))
                    tmpCart[this.tmpIndex] = cart
                    localStorage.setItem(this.slug, JSON.stringify(tmpCart))
                } else {
                    let tmpCartInitial = {}
                    tmpCartInitial[0] = cart
                    // tmpCartInitial[this.prodId] = cart
                    localStorage.setItem(this.slug, JSON.stringify(tmpCartInitial))
                }

                this.updateCartTmp(localStorage.getItem(this.slug))

                setTimeout(() => {
                    this.overlayProd = false
                    this.dialogProd = false
                }, 300);
                setTimeout(() => {
                    this.$notify.success(this.$t('Carrito actualizado con éxito.'));
                }, 500);
            },
            /**
             * calculate total
             */
            calculateTotal() {
                this.total = 0
                Object.keys(this.cart).forEach(key => {
                    this.total += this.cart[key].price
                });
            },

            /**
             *
             * ---------------- order -----------
             *
             */
            async sendOrder() {
                if (this.tmpPhone) {
                    // validación de número de celular para Bolivia
                    if (this.phoneIso == 'BO') {
                        const digits = (this.phoneNumber || '').replace(/\D/g, '');
                        this.phoneValid = /^[567]\d{7}$/.test(digits); // 8 dígitos, empieza con 5, 6 o 7
                    }

                    // validación de número de celular para otros países
                    if (!this.phoneValid) {
                        this.$alert(this.$t('Número de celular inválido.'))
                        return
                    }
                }
                if (this.$refs.refOrder.validate()) {
                    this.loading = true
                    // send data
                    const dataForm = new FormData()
                    dataForm.append('store', this.slug)
                    // type de la orden
                    dataForm.append('table_number', this.dataPrch.tableNumber)
                    // datos personales
                    dataForm.append('full_name', this.dataPrch.fullName)
                    dataForm.append('phone_number', this.phoneNumber)
                    dataForm.append('code', this.phoneCode)
                    // resumen de orden
                    dataForm.append('remark_order', (this.dataPrch.remarkOrder)?1:0)
                    dataForm.append('comment_order', this.dataPrch.commentOrder)
                    // carrito
                    dataForm.append('cart', JSON.stringify(this.cart))
                    dataForm.append('total', this.total)
                    dataForm.append('gralDiscount', 0)
                    dataForm.append('payment', 'Efectivo')
                    const url = this.mesa ? '/send-order-guest' : '/waiter/send-order';
                    await axios.post(url, dataForm)
                    .then((response) => {
                         console.log(response.data)
                        if (response.data[0] === 'ok') {
                            this.$fire({
                                title: this.$t('Pedido tomado con éxito.'),
                                text: this.$t('Su pedido fue realizado con éxito.'),
                                type: 'success',
                                confirmButtonText: this.$t('Entendido'),
                                confirmButtonColor: this.btnColor,
                                cancelButtonText: this.$t('No hacer nada'),
                                reverseButtons: true,
                                showCancelButton: false,
                                customClass: {
                                    container: this.fontFamily
                                }
                            }).then(resp => {
                                if (resp.value) {
                                    // reload page
                                    window.location.reload()
                                }
                            })

                            this.clearData()

                        }
                        this.loading = false
                    })
                    .catch((error) => {
                        // console.log(error.response)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert(this.$t('Error con el servidor, por favor vuelva a intentarlo más tarde.'));
                        }
                        if (error.response.status == 419) {
                            this.$fire({
                                title: this.$t('Sesión duplicada'),
                                text: '',
                                type: 'info',
                                confirmButtonText: this.$t('Entendido'),
                                confirmButtonColor: this.btnColor,
                                reverseButtons: true,
                                showCancelButton: false,
                                customClass: {
                                    container: this.fontFamily
                                }
                            }).then(resp => {
                                if (resp.value) {
                                    window.location.href='/login'
                                }
                            })
                        }
                        this.loading = false
                    })
                    // send data END
                } else {
                    this.$notify.error(this.$t('Campos requeridos vacios'))
                }
            },
            clearData() {
                this.dataPrch.fullName = ''
                this.phoneNumber = ''
                this.phoneCode = ''
                this.dataPrch.remarkOrder = false
                this.dataPrch.commentOrder = ''

                this.dialogPurchase = false
                this.openCart = false
                this.cart = {}
                this.cantProds = 0
                this.calculateTotal()

                this.$emit('send-success')

                localStorage.removeItem(this.slug)
            }
        },
    }
</script>
